<template>
  <section class="has-text-default mt-40 mx-20">
    <div class="level">
      <div class="level-left">
        <a
          class="level-item mr-20"
          @click="$router.go(-1)">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </a>
        <div class="level-item is-size-4 has-text-grid-4 has-text-weight-bold">
          {{$t('tableauDeBord.titlePageListeRecommendation')}}
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <BtnCreerRecommendation />
        </div>
      </div>
    </div>
    <liste-recom checkable/>
  </section>
</template>

<script>
import ListeRecom from '@/components/tableauDeBord/ListeRecom.vue';
import BtnCreerRecommendation from '@/components/general/BtnCreerRecom.vue';

export default {
  components: {
    ListeRecom,
    BtnCreerRecommendation,
  },
};
</script>
